var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRatingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4945 1.79698C12.9045 0.585651 14.6178 0.585653 15.0278 1.79698L17.2064 8.2339C17.3902 8.77694 17.8997 9.1424 18.473 9.1424H25.4033C26.7119 9.1424 27.2416 10.8278 26.1683 11.5764L20.6567 15.4206C20.1688 15.7609 19.9644 16.3826 20.1551 16.946L22.2823 23.231C22.696 24.4534 21.3092 25.4947 20.2507 24.7564L14.5261 20.7637C14.0665 20.4431 13.4558 20.4431 12.9962 20.7637L7.27161 24.7564C6.21311 25.4947 4.82629 24.4534 5.24003 23.231L7.36721 16.946C7.55792 16.3826 7.35348 15.7609 6.86557 15.4206L1.35399 11.5764C0.280718 10.8278 0.810412 9.1424 2.11896 9.1424H9.0493C9.6226 9.1424 10.1321 8.77694 10.3159 8.2339L12.4945 1.79698Z",
    fill: "#F1CD11"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingIcon);
export default __webpack_public_path__ + "static/media/rating-icon.9ba16c58812b8f3d177e6fc71e4ccb75.svg";
export { ForwardRef as ReactComponent };